// Variant change
this.customVariantChangeEvent = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    // console.info('%c[Variant changed]', 'color: #5fb8ff')
    // console.log(event.data)
    updateProductPrice(event.data.variant);
    checkOutOfStockButton(event.data.variant);
});

// Cart change
this.customCartChangeEvent = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    // console.info('%c[Cart updated]', 'color: #5fb8ff')
    // console.log(event)
});

// Cart error
this.customCartErorrEvent = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
    // console.info('%c[Cart error]', 'color: #5fb8ff')
    // console.log(event)
});

// Qty change
this.customQtyChangeEvent = subscribe(PUB_SUB_EVENTS.quantityUpdate, (event) => {
    // console.info('%c[Quantity updated]', 'color: #5fb8ff')
    // console.log(event.data)
});

// Options change
this.customOptionsChangeEvent = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
    // console.info('%c[Options change]', 'color: #5fb8ff')
    // console.log(event.data)
});

// Product info loaded
document.addEventListener('product-info:loaded', (...event) => {
    console.info('%c[Product Info Loaded]', 'color: #5fb8ff');
    checkProductInfo();
});

// Check variant availability on page load
document.addEventListener('DOMContentLoaded', () => {
    checkVariantOnPageLoad();
});

function checkProductInfo() {
    const addButton = document.querySelector('.product-form__buttons button[name="add"]');
    // Also check variant on product info load
    checkVariantOnPageLoad();
}

function checkVariantOnPageLoad() {
    console.log('checkVariantOnPageLoad');

    // Check if we're on a product template and have theme.product
    if (!window.theme || !window.theme.isProductTemplate || !window.theme.product) {
        console.log('Not on product template or no theme.product available');
        return;
    }

    // Check for URL variant parameter
    const urlParams = new URLSearchParams(window.location.search);
    const variantIdFromUrl = urlParams.get('variant');

    if (variantIdFromUrl) {
        console.log('Variant ID from URL parameter:', variantIdFromUrl);
    }

    // Use theme.product for variant availability check
    console.log('Using theme.product for page load check:', window.theme.product);

    // Add a small delay to ensure DOM elements are ready, especially dynamic ones
    setTimeout(() => {
        checkOutOfStockButton(window.theme.product);
    }, 100);
}

function updateProductPrice(variant) {
    const priceContainer = document.querySelector('[data-price-field]');
    if (!priceContainer) return;

    const priceHtml = [];

    if (variant.compare_at_price > variant.price) {
        priceHtml.push(`
            <span class="inline-block line-through product-compare-price">
                ${formatMoney(variant.compare_at_price)}
            </span>
            <span class="inline-block text--price on-sale">
                ${formatMoney(variant.price)}
            </span>
        `);
    } else {
        priceHtml.push(`
            <span class="text--price">
                ${formatMoney(variant.price)}
            </span>
        `);
    }

    priceContainer.innerHTML = `
        <div class="flex gap-1 leading-none">
            ${priceHtml.join('')}
        </div>
    `;
}

function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    return '£' + (cents / 100).toFixed(2);
}

function checkOutOfStockButton(variant) {
    console.log('checkOutOfStockButton', variant);

    // Try multiple selectors for Klaviyo button as it's dynamically generated
    const klaviyoButton = document.querySelector('.klaviyo-bis-trigger') ||
                         document.querySelector('.klaviyo-back-in-stock-button') ||
                         document.querySelector('a[href*="klaviyo"]') ||
                         document.querySelector('[data-testid="back-in-stock"]');

    // Try multiple selectors for buy buttons, including more specific ones for dynamic content
    const buyButtons = document.querySelectorAll('.product-form__buttons') ||
                      document.querySelectorAll('product-form .product-form__buttons') ||
                      document.querySelectorAll('[data-add-to-cart]');

    // Also try to find individual submit buttons
    const submitButtons = document.querySelectorAll('button[name="add"], .product-form__submit, [data-add-to-cart]');

    console.log('Klaviyo button found:', klaviyoButton);
    console.log('Buy button containers found:', buyButtons.length);
    console.log('Submit buttons found:', submitButtons.length);

    // If no klaviyo button found, try waiting a bit for it to be injected
    if (!klaviyoButton) {
        console.warn('No Klaviyo button found, retrying in 500ms...');
        setTimeout(() => checkOutOfStockButton(variant), 500);
        return;
    }

    if (variant && variant.available) {
        console.log('Variant available - hiding klaviyo, showing buy buttons');
        klaviyoButton.style.display = 'none';

        // Show buy button containers
        buyButtons.forEach(btn => {
            btn.style.display = '';
            btn.style.visibility = 'visible';
        });

        // Ensure submit buttons are enabled and visible
        submitButtons.forEach(btn => {
            btn.style.display = '';
            btn.style.visibility = 'visible';
            btn.disabled = false;
        });
    } else {
        console.log('Variant not available - showing klaviyo, hiding buy buttons');
        klaviyoButton.style.display = 'block';
        klaviyoButton.style.visibility = 'visible';

        // Hide buy button containers
        buyButtons.forEach(btn => {
            btn.style.display = 'none';
        });

        // Hide/disable submit buttons
        submitButtons.forEach(btn => {
            btn.style.display = 'none';
            btn.disabled = true;
        });
    }
}